import React from "react";
import LogoName from "../../assets/images/LogoName.png";
import LogoColor from "../../assets/images/Logo_Color.svg";
import HeroImage from "../../assets/images/Image.svg";
import "../../styles/Auth/auth-premium.css";

interface AuthShellProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  heroHeading: string;
  heroText: string;
  isMobile: boolean;
  children: React.ReactNode;
  footer: React.ReactNode;
}

const AuthShell: React.FC<AuthShellProps> = ({
  eyebrow,
  title,
  subtitle,
  heroHeading,
  heroText,
  isMobile,
  children,
  footer,
}) => {
  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-card">
          <div className="auth-form-panel">
            <div className="auth-form-inner">
              {isMobile && (
                <div className="auth-mobile-logo">
                  <img src={LogoName} alt="Sprooze" />
                </div>
              )}

              <span className="auth-eyebrow">{eyebrow}</span>
              <h1 className="auth-title">{title}</h1>
              <p className="auth-subtitle">{subtitle}</p>

              {children}

              <div className="auth-footer">{footer}</div>
            </div>
          </div>

          {!isMobile && (
            <div className="auth-hero-panel">
              <div className="auth-hero-visual" aria-hidden="true">
                <img src={HeroImage} alt="" className="auth-hero-visual-img" />
                <div className="auth-hero-overlay" />
              </div>

              <div className="auth-hero-inner">
                <div className="auth-hero-content">
                  <div className="auth-hero-logo">
                    <img src={LogoColor} alt="Sprooze" />
                  </div>
                  <h2 className="auth-hero-heading">{heroHeading}</h2>
                  <p className="auth-hero-text">{heroText}</p>
                  <ul className="auth-hero-features">
                    <li>Streamlined hiring workflows</li>
                    <li>AI-powered candidate matching</li>
                    <li>All-in-one recruitment platform</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
